import React from 'react'
import { useSearchParams, useLocation } from 'react-router-dom'

export default function TestPaymentPage() {
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const sessionId = searchParams.get('session_id')

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <h1 className="text-2xl font-bold text-green-600 mb-4">
          ✅ Test Payment Page Working!
        </h1>
        <p className="text-gray-600 mb-4">
          This page confirms that the routing is working correctly.
        </p>
        
        <div className="bg-gray-100 rounded-lg p-4 mb-6">
          <h3 className="font-semibold mb-2">Debug Information:</h3>
          <p className="text-sm text-gray-700 mb-1">
            <strong>Path:</strong> {location.pathname}
          </p>
          <p className="text-sm text-gray-700 mb-1">
            <strong>Search:</strong> {location.search}
          </p>
          <p className="text-sm text-gray-700 mb-1">
            <strong>Session ID:</strong> {sessionId || 'None'}
          </p>
          <p className="text-sm text-gray-700">
            <strong>Full URL:</strong> {window.location.href}
          </p>
        </div>

        <div className="space-y-3">
          <a
            href="/"
            className="block w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Go to Home
          </a>
          <a
            href="/payment-success?session_id=test_123"
            className="block w-full bg-green-600 text-white py-3 px-4 rounded-lg hover:bg-green-700 transition-colors"
          >
            Test Payment Success
          </a>
        </div>
      </div>
    </div>
  )
} 